import { Link } from '@tanstack/react-router'
import { Button } from '@/components/ui/button'
export function NotFoundPage() {
  return (
    <main className="center-screen">
      <h1>ไม่พบหน้าที่ต้องการ</h1>
      <Button asChild>
        <Link to="/">กลับหน้าหลัก</Link>
      </Button>
    </main>
  )
}
